<template>
    <BackButton @click="beb"/>
    <div class="languages">
        <div class="language" id="RU" @click="changeLanguage">
            <div class="firstLang">
                <img src="../assets/icons/ru.svg"/>
                <p>{{ $t("russian") }}</p>
                <p style="color:#808080;">Russian</p>
            </div>
            <img class="galka" src="../assets/icons/galka.svg" v-if="lang == 'RU'"/>
        </div>
        <hr class="hrSetting">
        <div class="language" id="EN" @click="changeLanguage">
            <div class="firstLang">
                <img src="../assets/icons/usa.svg"/>
                <p>{{ $t("englishUS") }}</p>
                <p style="color:#808080;">English</p>
            </div>
            <img class="galka" src="../assets/icons/galka.svg" v-if="lang == 'EN'"/>
        </div>
    </div>
</template>

<script>
import { BackButton } from 'vue-tg'
export default {
    name: "SelectLanguage",
    data() {
        return {
            lang: this.$store.getters.getLanguage
        }
    },
    methods: {
        beb() {
            this.$emit('changeMode', "SelectLanguage")
        },
        changeLanguage(event) {
            const selected = event.target.closest('div.language')?.id
            if (!selected) return
            this.lang = selected
            this.$store.commit('setLanguage', selected)
            this.$i18n.locale = selected
        }
    },
    components: {BackButton}
};
</script>

<style scoped>
.languages {
    background-color: var(--second-color);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    position: relative;
}
.language {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 17px;
    padding: 2.5%;
    transition: all 0.3s;
    cursor: pointer;
}
.language:active {
  scale:0.97;
}
.firstLang {
    display: flex;
    gap:10px;
    align-items: center;
}
.galka {
    width:7vw;
}
.hrSetting {
  width: 85%;
  float: right;
  position: absolute;
  right: 0;
  top: 50%;
  border: 0.5px solid var(--hr-color);
}
</style>
